import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { canSplitGroup } from "@redotech/redo-fulfillment-operations-common/split-fulfillment-group";
import SplitIcon from "@redotech/redo-icons/git-branch-01.svg";
import {
  RedoButton,
  RedoButtonSize,
} from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { DisabledTooltip } from "@redotech/redo-web/arbiter-components/tooltip/disabled-tooltip";
import { memo, useMemo, useState } from "react";
import { SplitGroupModal } from "./split-group-modal";

export const SplitGroupButton = memo(function SplitGroupButton({
  disabled,
  fulfillmentGroup,
  setRows,
  triggerReload,
  size = "md",
  isSlideout,
}: {
  disabled: boolean;
  fulfillmentGroup: FulfillmentGroupData;
  setRows?: (value: React.SetStateAction<FulfillmentGroupData[]>) => void;
  triggerReload: () => Promise<void>;
  size?: RedoButtonSize;
  isSlideout: boolean;
}) {
  const [open, setOpen] = useState<boolean>(false);

  const { canSplit, disabledMessage } = useMemo(
    () => canSplitGroup(fulfillmentGroup),
    [fulfillmentGroup],
  );

  return (
    <>
      <DisabledTooltip disabledMessage={disabledMessage}>
        <RedoButton
          disabled={disabled || !canSplit}
          hierarchy="secondary"
          IconLeading={SplitIcon}
          onClick={() => {
            setOpen(!open);
          }}
          size={size}
          text="Split fulfillment"
          theme="normal"
        />
      </DisabledTooltip>
      <SplitGroupModal
        group={fulfillmentGroup}
        isSlideout={isSlideout}
        open={open}
        setOpen={setOpen}
        setRows={setRows}
        triggerReload={triggerReload}
      />
    </>
  );
});
